import { useCallback, useRef, useState } from "react"

import { FiSend, FiSquare } from "react-icons/fi"

import { MAX_MESSAGE_LENGTH } from "../../constants/chat"

import { InputContainer, SendButton, TextArea } from "./styles"

const ChatInput = ({ onSend, onStop, isStreaming }) => {
   const [value, setValue] = useState("")
   const textAreaRef = useRef(null)

   const handleSend = useCallback(() => {
      if (!value.trim() || isStreaming) return
      onSend(value.slice(0, MAX_MESSAGE_LENGTH))
      setValue("")
      if (textAreaRef.current) {
         textAreaRef.current.style.height = "auto"
      }
   }, [value, isStreaming, onSend])

   const handleKeyDown = useCallback(
      (e) => {
         if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault()
            handleSend()
         }
      },
      [handleSend],
   )

   const handleChange = useCallback((e) => {
      const newValue = e.target.value
      if (newValue.length > MAX_MESSAGE_LENGTH) return
      setValue(newValue)
      const el = e.target
      el.style.height = "auto"
      el.style.height = Math.min(el.scrollHeight, 100) + "px"
   }, [])

   return (
      <InputContainer>
         <TextArea
            ref={textAreaRef}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Describe your shipment..."
            rows={1}
            maxLength={MAX_MESSAGE_LENGTH}
            aria-label="Chat message input"
         />
         {isStreaming ? (
            <SendButton $isStreaming onClick={onStop} title="Stop generating" aria-label="Stop generating">
               <FiSquare />
            </SendButton>
         ) : (
            <SendButton onClick={handleSend} disabled={!value.trim()} title="Send message" aria-label="Send message">
               <FiSend />
            </SendButton>
         )}
      </InputContainer>
   )
}

export default ChatInput
